import React, { useState } from 'react';
import s from './SignalTranslation.module.scss';
import { FormattedMessage } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Activity from '../WSAControls/Activity/Activity';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const SignalTranslationComments = ({ signalTranslationManager, unitSerialNumber, saveSignalTranslationComment, UpdateAllowed, intl, currentTimezone }) => {
  const [signalTranslationComment, setSignalTranslationComment] = useState('');
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const commentChangeHandler = e => {
    setSignalTranslationComment(e.target.value);
  };

  const commentSaveHandler = () => {
    if (signalTranslationComment.length > 0) {
      const signalTranslationConstant = [
        {
          GuidIdentifier: uuidv4(),
          Description: signalTranslationComment,
          IsActive: true,
          UpdatedBy: Cookies.get(`userid-${envName}`) || null
        }
      ];

      const saveData = {
        SignalTranslationId: signalTranslationManager.SelectedSignalTranslation.SignalTranslationId,
        SignalTranslationComments: signalTranslationConstant
      };
      saveSignalTranslationComment(saveData, unitSerialNumber, 'SIGNALTRANSLATION_COMMENT_ADD');
      setSignalTranslationComment('');
    }
  };

  const commentCancelHandler = () => {
    setSignalTranslationComment('');
  };

  const comments = () => {
    let commentstData = signalTranslationManager.SelectedSignalTranslation.SignalTranslationComments || [];

    if (commentstData && commentstData.length > 0) {
      commentstData = commentstData.map(comment => ({ ...comment, Id: comment.SignalTranslationCommentId }));
    }

    return commentstData;
  };

  const headertext = '';

  return (
    <div className={s.signalTranslation}>
      <div className={s.contentWrapper}>
        <div className={s.signalTranslationComment}>
          {signalTranslationManager.isLoading && <LoadingSpinner centeredLoading={false} />}
          <Row className={s.breakrow}>
            <Col sm={12}>
              <h4>
                <FormattedMessage id="signalTranslation.comments" defaultMessage="Comments" />
                <span data-unittest="signalTranslationDataCount" className={s.circle}>
                  {signalTranslationManager.SelectedSignalTranslation.SignalTranslationComments.length}
                </span>
              </h4>
            </Col>
          </Row>
          <Row className={s.breakrow}>
            <Col sm={12}>
              <Activity
                description={signalTranslationComment || ''}
                onActivityModified={commentChangeHandler}
                onSaveClick={commentSaveHandler}
                onCancelClick={commentCancelHandler}
                currentTimezone={currentTimezone}
                activities={comments()}
                isUpdateAllowed={UpdateAllowed}
                isViewAllowed={true}
                headingText={headertext}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SignalTranslationComments;
